/**
 * Chat-turn error names (the API's `ChatbotExceptionName`) that have a
 * `CHAT.ERRORS.<name>` translation. Any other name still reaches the toast
 * as-is. SB-3978 follow-up #1808.
 */
export const TRANSLATED_CHAT_ERRORS: readonly string[] = [
  'CHATBOT_GENERATE_TEAMMATE_ANSWER_ERROR',
  'CHATBOT_TEAMMATE_NOT_CONVERSABLE',
];

/**
 * The translation key for a message's error, or `null` when it has none.
 * Only a mapped name goes through `translate`: a raw error that happened to
 * match a translation path would otherwise be swapped for that entry.
 */
export const toChatErrorToastKey = (error: string): string | null =>
  TRANSLATED_CHAT_ERRORS.includes(error) ? `CHAT.ERRORS.${error}` : null;
